var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['rank-avatar relative', _vm.rankingClass],style:({
    backgroundImage: `url('${_vm.avatarImg}')`
  })},[([1, 2, 3].includes(_vm.ranking))?_c('img',{staticClass:"crown absolute",attrs:{"src":_vm.crownImg}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }